import React from 'react';
import { compose } from 'ramda';

import { RichText, Image } from '@synergycms_core/components/generic/';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import styleFile from './Loading.js';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';

const Loading = class Loading extends React.Component {
  static displayName = 'Loading';
  render() {
    const { config, theme} = this.props;
    const { classes } = theme.styles;
    const { showloyaltyBanner } = config;

    return (
      <div className={[theme.computedInnerStyle,classes.loadingTable].join(' ')}>
        <div className={classes.loadingWrapper}>
          <div className={classes.loadingContainer}>
            <div className={classes.loadingContent}>
              <div className={classes.loadingTitle}>
                <Image innerStyle={classes.loadingSvg} svg={'loadingSvg'} config={config.image}/>
                <RichText
                  defaultStyle={false}
                  translate={true}
                  innerStyle={classes.title}
                  ucFirst={true}
                  text={'_%cargando%_'}
                />
                <RichText defaultStyle={false} innerStyle={classes.descriptionText} config={config.richText}>
                  {config.text}
                </RichText>
              </div>
              {/*
              <div className={classes.loadingBackground} style={{ backgroundImage: 'url(./assets/icons/sW.png)' }}>
                <div className={classes.starLogo}>
                  <Image svg={'loyalty'} />
                </div>
                <RichText innerStyle={classes.loadingTitle1} translate={true} text={'_%star traveler%_'} />
                <RichText innerStyle={classes.loadingTitle2} translate={true} text={'_%un universo de ventajas%_'} />
                <ul className={classes.loadingAdvantage}>
                  <li className={classes.advantageBreakfast}>
                    <RichText innerStyle={'roboto16White'} translate={true} text={'_%desayuno%_'} />
                    <RichText innerStyle={'roboto16White'} translate={true} text={'_%gratuito%_'} />
                  </li>
                  <li className={classes.advantageCheck}>
                    <RichText innerStyle={'roboto16White'} translate={true} text={'_%early Check in%_;'} />
                    <RichText innerStyle={'roboto16White'} text={'&amp;'} />
                    <RichText innerStyle={'roboto16White'} translate={true} text={'_%late Check out%_'} />
                  </li>
                  <li className={classes.advantageWater}>
                    <RichText innerStyle={'roboto16White'} translate={true} text={'_%botella de agua%_'} />
                    <RichText innerStyle={'roboto16White'} translate={true} text={'_%de bienvenida%_'} />
                  </li>
                </ul>
              </div>
              */}
              {showloyaltyBanner && (
                <div className={classes.starLoadingContainer}>
                  <div className={classes.starLoadingMax}>
                    <div className={classes.starLogo}>
                      <Image svg={'loyalty'} />
                    </div>
                    <RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%elige nuestra tarifa star traveler y disfruta de tu descuento%_'}
                      innerStyle={classes.starTitle}
                    />
                    <RichText
                      translate={true}
                      ucFirst={true}
                      text={'_%nosotros nos encargamos de darte de alta en nuestro programa de fidelización.%_'}
                      innerStyle={classes.starSubTitle}
                    />
                  </div>
                </div>
              )
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default compose(
  PropertyManager(['text', 'richText', 'image', 'showloyaltyBanner']),
  withContent('contentTheme'),
  withThemeJSS({ styleFile, link: true })
)(Loading);
